import * as actionTypes from "../../actionLabels/index";

const initialState = {
  genSellerTaxInvoiceView: [],
  genSellerTaxInvoiceSearch: [],
  genSellerTaxInvoiceCreate: [],
  ApiStatusSellerTax: false,
  genSellerToAuctioneerTaxInvoiceViewId: null,
  isGenerateInvoiceButtonDisabled: false,
  isSearchInvoiceButtonDisabled: false,
};

const generateSellerTaxInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_SUCCESS:
      console.log(action.payload, "genSellerTaxInvoiceView_check");
      return {
        ...state,
        genSellerTaxInvoiceView: action.payload,
        error: null,
      };
    case actionTypes.SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL:
      return {
        ...state,
        genSellerToAuctioneerTaxInvoiceViewId: action.payload,
        error: null,
      };
    case actionTypes.SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL_FAIL:
      return {
        ...state,
        genSellerTaxInvoiceView: [],
        error: action.payload,
      };
    case actionTypes.SELLERTOAUCTIONEERINVOICE_SEARCH_SUCCESS:
      console.log(action.payload, "genSellerTaxInvoiceView_check_search");

      return {
        ...state,
        genSellerTaxInvoiceSearch: action.payload,
        error: null,
      };
    case actionTypes.SELLERTOAUCTIONEERINVOICE_SEARCH_FAIL:
      return {
        ...state,
        genSellerTaxInvoiceSearch: [],
        error: action.payload,
      };
    case actionTypes.SELLERTOAUCTIONEERINVOICE_CREATE_SUCCESS:
      return {
        ...state,
        genSellerTaxInvoiceCreate: action.payload,
        error: null,
      };
    case actionTypes.SELLERTOAUCTIONEERINVOICE_CREATE_FAIL:
      return {
        ...state,
        genSellerTaxInvoiceCreate: [],
        error: action.payload,
      };

    case actionTypes.API_STATUS_SELLER_TAX:
      return {
        ...state,
        ApiStatusSellerTax: action.payload.data,
      };



      case actionTypes.DISABLE_GENERATE_INVOICE_BUTTON:
        return {
          ...state,
          isGenerateInvoiceButtonDisabled: true,
        };
  

      case actionTypes.ENABLE_GENERATE_INVOICE_BUTTON:
        return {
          ...state,
          isGenerateInvoiceButtonDisabled: false, 
        };

      case actionTypes.DISABLE_SEARCH_INVOICE_BUTTON:
        return{
          ...state,
          isSearchInvoiceButtonDisabled:true,
        }

      case actionTypes.ENABLE_SEARCH_INVOICE_BUTTON:
        return{
          ...state,
          isSearchInvoiceButtonDisabled: false,
        }

    default:
      return state;
  }
};
export default generateSellerTaxInvoiceReducer;
